import { dataKeyDelete } from 'dls-icons-data'
import { createIcon } from '../common'

const IconKeyDelete = /*#__PURE__*/createIcon(dataKeyDelete)
export default IconKeyDelete
